import React from "react";
import { resolveMedia } from "@/lib/api";
import { CurrencyDollar } from "@phosphor-icons/react";

const METHODS = [
  { key: "zelle", name: "Zelle", color: "#6D1ED4", hint: "Send to" },
  { key: "venmo", name: "Venmo", color: "#008CFF", hint: "Pay" },
];

export function PaymentInfo({ payments }) {
  if (!payments || !payments.enabled) return null;
  const active = METHODS.filter((m) => payments[m.key] && payments[m.key].enabled && (payments[m.key].label || payments[m.key].qr_url));
  if (active.length === 0 && !payments.instructions) return null;

  return (
    <div className="border border-white/10 bg-[#121212] p-6 mt-10" data-testid="payment-info">
      <div className="flex items-center gap-2 mb-4">
        <CurrencyDollar size={22} weight="fill" className="text-[#FF5722]" />
        <h3 className="font-display text-2xl uppercase">Pay Your League Fees</h3>
      </div>
      {payments.instructions && <p className="text-white/70 text-sm mb-5 whitespace-pre-line">{payments.instructions}</p>}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {active.map((m) => {
          const info = payments[m.key];
          return (
            <div key={m.key} className="border border-white/10 bg-black/30 p-4" data-testid={`payment-method-${m.key}`}>
              <span className="inline-block text-[11px] font-bold uppercase tracking-wider px-2.5 py-1 mb-3" style={{ background: m.color, color: "#fff" }}>{m.name}</span>
              {info.label && (
                <div className="mb-3">
                  <div className="text-[10px] uppercase tracking-wide text-white/40">{m.hint}</div>
                  <div className="text-white font-semibold break-all select-all">{info.label}</div>
                </div>
              )}
              {info.qr_url && (
                <img src={resolveMedia(info.qr_url)} alt={`${m.name} QR code`} className="w-40 h-40 object-contain bg-white p-2" />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
